<template>
  <div class="Register">
    <div class="header" v-if="!$store.state.mediaPhone">
      <link_wp :link="topLink[0]" :isBefore="1" ></link_wp>
      <link_wp :link="topLink[1]" ></link_wp>
    </div>
    <div class="form">
      <logo :logo="logo"></logo>
      <div class="title fs18">{{title}}</div>
      <input id="username" type="text" :value="fakeform['name']" autocomplete="off" style="display:none"/>
      <input id="password" type="password" :value="fakeform['pass']"  autocomplete="off" style="display:none"/>
      <my_button class="sendCode" :inputStyle="codeStyle" :value="scode" @click.native="sendCode" :disable="!checkMobile() || codeDelay>0"></my_button>
      <my_input v-for="f in forms" :key="f.label" :placeholder="f.placeholder" v-model="fm[f.label]" :type="f.type" :error="error[f.label]" :disfill="1"></my_input>
      <span :title="checkRegister()?'':'请先填写表单'"><my_button class="btn" :value="btn" @click.native="submit" :disable="!checkRegister()"></my_button></span>
    <div class="tips">
      <div>已有账号？</div>
      <my_link :link="tips.link" :inputStyle="tips.style"></my_link>
    </div>
    </div>
    <div class="float">
      <!-- <div class="oversea" @click="wenjuan()">Oversea Users?</div>
           <span title="港澳台用户请使用 3 位区号(如 852, 无需加号) + 8 位电话的格式" ><div class="question">?</div></span> -->
    </div>
  </div>
</template>

<script>
 import Logo from '@/components/Logo.vue';
 import MyLink from '@/components/Link.vue';
 import LinkWP from '@/components/LinkWithPseudo.vue';
 import MyInput from '@/components/Input.vue';
 import MyButton from '@/components/Button.vue';
 
 export default {
   name: 'Register',
   data () {
     return {
       fm: {
         phone: '',
         code: '',
         name: '',
         password: '',
         password_confirmation: '',
       },
       error: {
         phone: '',
         code: '',
         name: '',
         password: '',
         password_confirmation: '',
       },
       reseting: false,
       scode: '发送验证码',
       codeDelay: 0,
       btn: '注册',
     }
   },
   watch: {
     fm : {
       handler() {
         if(!this.reseting)
           this.resetError();
       },
       deep: true
     }
   },
   methods: {
     wenjuan() {
       window.open('https://wj.qq.com/s2/6706328/1bf9/', '_blank');
     },
     resetError() {
       this.error = {
         phone: '',
         code: '',
         name: '',
         password: '',
         password_confirmation: '',
       }
     },
     checkMobile () {
       if(!this.fm.phone)
         return false
       let patt = new RegExp(/^\d{11}$/);
       let res = patt.test(this.fm.phone)
       if(res)
         {
           this.error.phone=''
         }
       else
         {
           this.error.phone='phone syntax error'
         }
       return res
     },
     checkRegister () {
       if(this.checkMobile())
         {
           return this.fm.code && this.fm.name && this.fm.password && this.fm.password_confirmation;
         }
       return false
     },
     sendCode () {
       if(this.codeDelay)
         return;

       let data = new FormData();
       data.set('phone', this.fm.phone);
       this.$http.post('/api/register/send_code', data)
           .then(res => {
             let text = '重试'
             this.codeDelay = 60;
             let that = this;
             let loop = setInterval(function() {
               that.codeDelay -= 1
               that.scode = text+'('+that.codeDelay+')';
               if(that.codeDelay== 0)
                 {
                   that.scode='发送验证码';
                   clearInterval(loop);
                 }
             }, 1000);
           })
           .catch(e => {
             let error = e.response.data.errors
             this.reseting = true;
             for(let e in error)
               {
                 this.fm[e] = ''
                 this.error[e] = error[e]
               }

             this.$nextTick(()=>{
               this.reseting = false
             })
           })

     },
     submit() {
       if(this.fm.password.length < 6)
         {
           this.reseting = true;
           this.fm.password = ''
           this.fm.password_confirmation = ''
           this.error.password='密码至少要6位'
             this.$nextTick(()=>{
               this.reseting = false
             })
           return 

         }
       if(this.fm.password != this.fm.password_confirmation)
         {
           this.reseting = true;
           this.fm.password_confirmation = ''
           this.error.password_confirmation='与密码不一致'
             this.$nextTick(()=>{
               this.reseting = false
             })
           return 
         }

       console.log('submit')
       this.btn = '注册中'
       let data = new FormData();
       data.set('phone', this.fm.phone);
       data.set('password', this.fm.password);
       data.set('password_confirmation', this.fm.password_confirmation);
       data.set('name', this.fm.name);
       data.set('code', this.fm.code);

       this.$http.post('/api/register', data)
           .then(res => {
             console.log(res)
             /* this.*/
             this.$store.commit('SET_TOKEN', res.data)
             this.$http.get('/api/login/me')
                    .then(me => {
                      console.log(me)
                      this.$store.commit('SET_USER', me.data)
                      if(this.$store.state.route.redirect)
                        {
                          this.$store.commit('UNSET_REDIRECT')
                          /* this.$router.push({name: 'frontpage'})*/
                          /* this.$router.history.go(-1);*/
                        }
                      this.$router.replace({name: 'frontpage'})
                    })
           })
           .catch(e => {
             console.log(e.response)
             this.btn = '注册'
             let error = e.response.data.errors
             this.reseting = true;
             for(let e in error)
               {
                 this.fm[e] = ''
                 /* this.$set(this.fm, e, '');*/

                 this.error[e] = error[e]
                 if(e == 'password')
                   {
                     this.fm['password_confirmation'] = '';
                   }
               }
             this.$nextTick(()=>{
               this.reseting = false
             })
           })
     }
   },
   computed: {
     fakeform() {
       return {
         name: this.fm.phone,
         pass: this.fm.password,
       }
     },
     topLink () {
       return this.$store.state.account.register.links
     },
     logo(){
       return this.$store.state.logo.mainBlack
     },
     title () {
       return '账号注册'
     },
     forms () {
       return this.$store.state.account.register.forms
     },
     tips () {
       return {
         link: {
           text:'立即登录',
           link: {
             name: 'account',
             params: {type: 'login'}
           }
         },
         style: {
           color: '#3388FF'
         }
       }
     },
     codeStyle() {
       return {
         height: this.$store.state.mediaPhone? '25px': '1.8vw',
         width: '7em',
         'font-size': this.$store.state.mediaPhone? '12px': '0.73vw',
         'border-radius': '5px',
       }
     }
   },
   components: {
     my_input: MyInput,
     my_button: MyButton,
     my_link: MyLink,
     link_wp: LinkWP,
     logo: Logo
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Register{
   width: 32.08vw;
   height:34.0625vw;
   background-color: white;

   box-sizing: border-box;
   padding-top: 1.32vw;
   padding-bottom: 1.2vw;
   padding-left: 3.18vw;
   padding-right: 3.18vw;

   position:relative;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   text-align: center;
 }
 .header{
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 1.5vw;
 }
 .form {
   position: relative;
 }
 .btn{
   margin-top: 1.6vw;
 }
 .title{
   color: #333333;
   margin-bottom: 0.36vw;
   margin-top: 1.875vw;
 }
 .tips{
   display: flex;
   justify-content: center;
 }
 .sendCode{
   position: absolute;
   right: 1vw;
   top: 10vw;
   bottom: 15.62vw;
 }
 .float{
   position: absolute;
   right: 5em;
   /* top: 10em; */
   top: 8.875vw;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    height: 5em;
 }
 .oversea{
   cursor: pointer;
   color: var(--blue);
 }
 .question{
   border: 1px solid #888;
   color: #888;
   border-radius: 50%;
   width: 1.2em;
   height: 1.2em;
   text-align:center;
   cursor: pointer;
   
 }
 .sendCode.disabled{
   background-color: grey;
 }
 @media (min-width: 320px) and (max-width: 480px) {
   .Register{
     width: 100vw;
     height: 100%;
     align-items:center;
     justify-content: center;
   }
   .form{
     height: 60%;
     width: 80%;
   }
   .title{
    margin-bottom: 6vh;
   }
  .btn{
   margin-top: 2vh;
    font-size: 12px;
 }
   .tips{
     margin-top: 4vw;
   }

 .sendCode{
   bottom: auto;
   top: calc(111px + 6vh);
 }
 }

</style>
